import React from "react";
import { Formik, Form } from "formik";
import { FormFirstStep } from "./firstStepForm";
import { StepButton } from "./stepButton";
import { FormFooter } from "./formFooter";
import * as Yup from "yup";
import { Modal, ModalBody } from "reactstrap";
import { store } from "../../redux/storeConfig/store";
import { updateFollowupProgram, createFollowupProgram } from "../../redux/actions/api/apiAction";
import Title from "../title";

function FollowupProgramForm({
  name,
  handleSubmit,
  handleSubmitForUpdate,
  followupPeriod,
  notifyOnMissedTasksAfter,
  followupOn,
  edit,
}) {
  const formSchema = Yup.object().shape({
    name: Yup.string()
      .max(100, "Cannot be more than 100 characters")
      .required("Program name is required"),
    followupPeriod: Yup.number()
      .required("Program period is required")
      .positive("Must be positive number"),
    notifyOnMissedTasksAfter: Yup.number()
      .required("Notification period is required")
      .positive("Must be positive number"),
    followupOn: Yup.array()
      .min(1, "At least one follow-up option must be selected")
      .required("Follow-up options are required"),
  });

  handleSubmit = async ({ 
    name, 
    followupPeriod, 
    notifyOnMissedTasksAfter, 
    followupOn, 
  }) => {
    store.dispatch(
      createFollowupProgram({ 
        data: {
          name,
          followupPeriod,
          notifyOnMissedTasksAfter,
          followupOn,
        }
      })
    );
  };

  const submit = (values) => {
    if (edit) {
      handleSubmitForUpdate(values);
    } else {
      handleSubmit(values);
    }
  };

  return (
    <ModalBody className="followup-program-first-step">
      <div className="modal-body-content">
        <div className="add-member-popup adding-popup bg-white card-panel">
          <div className="basic-info">
            <div className="info-title with-border">
              <Title
                title={edit ? "Edit Follow-up Program" : "Add New Follow-up Program"}
                subtitlestyle="ctf-tx-secondary"
                subtitle="Add details for the program"
              />
            </div>
            <Formik
              enableReinitialize
              initialValues={{
                name: name || "",
                followupPeriod: followupPeriod || "",
                notifyOnMissedTasksAfter: notifyOnMissedTasksAfter || "",
                followupOn: followupOn || [],
                edit: edit || false,
              }}
              onSubmit={submit}
              validationSchema={formSchema}
            >
              {(formikProps) => (
                <Form>
                  <FormFirstStep {...formikProps} />
                  <StepButton edit={edit} />
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </ModalBody>
  );
}

FollowupProgramForm.defaultProps = {
  name: "",
  followupPeriod: "",
  notifyOnMissedTasksAfter: "",
  followupOn: [],
  edit: false,
  handleSubmit: () => {},
  handleSubmitForUpdate: () => {},
};

export default FollowupProgramForm;